

































import Vue from 'vue';
import SToolbar from '../../SToolbar/SToolbar.vue';
import SToolbarTitle from '../../SToolbarTitle/SToolbarTitle.vue';

/**
 * Used by the `SDialog` component
 */
export default Vue.extend({
  name: 'SDialogHeader',
  components: {
    SToolbar,
    SToolbarTitle,
  },
  props: {
    /**
     * @deprecated Not used for anything
     */
    id: {
      type: String,
      required: false,
    },
    /**
     * @see src/components/SToolbarTitle/SToolbarTitle.vue#title
     */
    title: {
      type: String,
      required: true,
    },
    /**
     * @see src/components/SToolbarTitle/SToolbarTitle.vue#subTitle
     */
    subTitle: {
      type: String,
      required: false,
    },
    /**
     * @deprecated Not used for anything
     */
    description: {
      type: String,
      required: false,
    },
    /**
     * @deprecated Not used for anything
     */
    subDescription: {
      type: String,
      required: false,
    },
    /**
     * Is used to work out the header color for `SToolbar` component
     */
    color: {
      type: String,
      required: false,
    },
    /**
     * @see src/components/SToolbarTitle/SToolbarTitle.vue#icon
     */
    icon: {
      type: String,
      required: false,
    },
    /**
     * @see src/components/SToolbarTitle/SToolbarTitle.vue#showIcon
     */
    showIcon: {
      type: Boolean,
      required: false,
    },
    /**
     * @deprecated Not used for anything
     */
    iconColor: {
      type: String,
      required: false,
    },
    /**
     * @deprecated Not used for anything
     */
    darkText: {
      type: Boolean,
      required: false,
    },
    /**
     * @deprecated Not used for anything
     */
    dense: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    headerClasses(): string {
      const classes: any = [];

      if (this.color) {
        classes.push(this.color);
      } else {
        classes.push('primary');
      }
      classes.push('darken-1');
      return classes.join(' ');
    },
    headerColor(): any {
      return this.color ? this.color : 'primary';
    },
    setIconColor(): any {
      return this.iconColor ? this.iconColor : 'white';
    },
  },
});
